<!-- @veltra/icons generated sha256:bd3a5ca981bd1e05 gen:8 source:src/svg/normal/arrow-right.svg -->
<script setup lang="ts">
defineOptions({ name: 'ArrowRight' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m6.015 12.013-.028-.027a.63.63 0 0 1 .011-.903L9.082 8 5.998 4.916a.651.651 0 0 1 .92-.918l3.65 3.65a.497.497 0 0 1 0 .704L6.918 12a.63.63 0 0 1-.903.012"
    />
  </svg>
</template>
